import React from 'react';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { startOfWeekMon, endOfWeekSun } from "../../utils/dateFunctions";
import DateSelector from "../../shared/DateSelector";
import WarehouseSelector from "../../components/WarehouseSelector";
import CreditMemoCreate from './FunctionalComp/CreditMemoCreate';
import CreditMemosEditable from './Tables/CreditMemoEditable';
import FormModal from '../../components/FormModal';
import ProjectSales from './Forms/ProjectSales';
import SalesOrdersComp from './FunctionalComp/SalesOrders'
import { checkAccess } from '../../utils/roleFunctions';
import { ACCESS, ACCESS_SECTIONS } from '../../utils/constants/access';
const CreditMemosPage = (props) => {
    const [startDate, setStartDate] = React.useState(startOfWeekMon(new Date()));
    const [endDate, setEndDate] = React.useState(endOfWeekSun(new Date()));
    const [data, setData] = React.useState(null);
    const [completed, setCompleted] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [location, setLocation] = React.useState(0);
    const [reload, setReload] = React.useState(true);
    const requiredEditAccess = { key: ACCESS_SECTIONS.SALES, value: ACCESS.EDIT };
    const requiredSalesOrderEditAccess = { key: ACCESS_SECTIONS.SALESORDEREDIT, value: ACCESS.EDIT };

    const reloadFunc = () => {
        setReload(!reload);
    }

    const createPO = (ser) => () => {
        setOpen(true);
        setEdit(false);
        setData(null);
    }
    
    const viewPO = (array) => (rowd, rowState) => {
        setData(array[rowState.dataIndex]);
        setOpen(true);
        setEdit(false);
        setCompleted(true);
    }
   
    return (
        <React.Fragment>
            
            <Grid container spacing={2} mb={1}>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <DateSelector montosun noForward startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                </Grid>
            </Grid>
            
            <Grid container spacing={3.5}>

                <Grid item xs={12}>
                    {checkAccess(props.access, requiredEditAccess)||checkAccess(props.access, requiredSalesOrderEditAccess) ?
                        <CreditMemoCreate access={props.access} reloadFunc={props.reloadFunc} reload={props.reload} createOne/> :
                        null}
                </Grid>
                <Grid item xs={12}>
                    <CreditMemosEditable location={location} startDate={startDate} endDate={endDate} access={props.access} onClick={viewPO}  reloadFunc={props.reloadFunc} reload={props.reload} dashboard summary/>
                </Grid>
        </Grid>
        </React.Fragment >
    );
};

export default CreditMemosPage;
